var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "29ea824543"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 92 77 L 283.511719 77 L 283.511719 298.53125 L 92 298.53125 Z M 92 77 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 170.34375 87.167969 C 164.703125 83.375 161.273438 81.476562 161.144531 81.40625 C 161.007812 81.332031 160.882812 81.242188 160.765625 81.148438 C 146.890625 83.304688 133.507812 89.234375 122.257812 98.921875 L 130.589844 107.253906 C 143.539062 95.0625 157.300781 89.242188 170.34375 87.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 134.222656 110.886719 L 153.972656 130.636719 C 168.28125 116.734375 181.203125 108.5 192.15625 103.765625 C 186.261719 98.773438 180.890625 94.636719 176.335938 91.347656 C 162.785156 92.550781 148.078125 97.878906 134.222656 110.886719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 249.296875 169.660156 C 249.238281 169.589844 249.175781 169.527344 249.125 169.449219 C 247.1875 166.355469 245.214844 163.378906 243.222656 160.457031 C 241.101562 173.394531 235.277344 187.027344 223.195312 199.859375 L 231.523438 208.1875 C 241.210938 196.929688 247.140625 183.539062 249.296875 169.660156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 221.949219 125.363281 C 225.886719 114.601562 225.863281 107.066406 225.492188 103.511719 C 221.683594 102.839844 213.527344 102.210938 202.140625 105.683594 C 208.433594 111.359375 215.128906 117.914062 221.949219 125.363281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 196.605469 107.617188 C 185.714844 111.886719 172.457031 119.863281 157.605469 134.269531 L 192.289062 168.953125 C 206.773438 154.078125 215.109375 141.117188 219.804688 130.628906 C 211.769531 121.695312 203.875 114.046875 196.605469 107.617188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 123.878906 182.828125 C 130.457031 190.175781 138.285156 198.121094 147.378906 206.171875 C 159.011719 199.375 173.074219 188.015625 188.671875 172.601562 L 153.964844 137.894531 C 141.601562 150.722656 130.273438 167.695312 123.878906 182.828125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 142.589844 208.78125 C 138.5 205.109375 134.640625 201.457031 131.066406 197.882812 C 127.757812 194.574219 124.671875 191.328125 121.796875 188.175781 C 118.433594 197.699219 117.375 206.125 119.695312 211.804688 C 124.71875 214.953125 132.578125 213.816406 142.589844 208.78125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 146.703125 212.398438 C 141.253906 215.304688 135.964844 217.398438 131.089844 218.257812 C 140.566406 222.742188 151.273438 225.664062 162.851562 225.355469 C 157.109375 221.070312 151.714844 216.730469 146.703125 212.398438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 215.957031 199.890625 L 192.304688 176.238281 C 181.226562 187.1875 166.035156 200.875 151.445312 209.707031 C 157.332031 214.722656 163.71875 219.75 170.613281 224.675781 C 184.804688 222.507812 200.125 215.183594 215.957031 199.890625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 239.054688 154.511719 C 233.960938 147.441406 228.757812 140.90625 223.578125 134.910156 C 218.472656 145.515625 209.933594 158.214844 195.921875 172.585938 L 219.566406 196.230469 C 232.445312 182.507812 237.789062 167.949219 239.054688 154.511719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 230.699219 110.675781 C 230.296875 115.566406 229.015625 121.988281 225.871094 129.734375 C 230.371094 134.859375 234.894531 140.367188 239.363281 146.277344 C 239.0625 131.300781 234.324219 118.410156 230.699219 110.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 197.574219 101.640625 C 204.539062 99.183594 210.546875 98.144531 215.425781 97.84375 C 207.710938 94.6875 196.871094 91.421875 184.617188 91.105469 C 188.566406 94.121094 192.929688 97.625 197.574219 101.640625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 150.332031 134.261719 L 130.5625 114.492188 C 115.128906 130.476562 107.816406 145.929688 105.722656 160.234375 C 109.394531 165.375 114.183594 171.636719 120.148438 178.570312 C 127.210938 162.808594 138.816406 146.214844 150.332031 134.261719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 113.453125 201.921875 C 113.863281 196.410156 115.46875 190.257812 117.9375 183.855469 C 112.902344 178.101562 108.625 172.753906 105.085938 168.042969 C 104.839844 180.503906 108.332031 191.949219 113.453125 201.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 176.726562 235.082031 C 174.121094 233.367188 171.578125 231.636719 169.101562 229.890625 C 157.96875 231.230469 146.707031 229.820312 135.503906 225.652344 C 146.796875 231.867188 159.527344 235.179688 172.773438 235.179688 C 174.09375 235.179688 175.414062 235.148438 176.726562 235.082031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 184.820312 234.242188 C 200.945312 231.742188 215.816406 224.238281 227.574219 212.472656 C 227.734375 212.3125 227.886719 212.140625 228.046875 211.980469 L 219.597656 203.527344 C 205.8125 216.839844 191.21875 225.226562 176.300781 228.632812 C 178.984375 230.453125 181.714844 232.257812 184.542969 234.03125 C 184.644531 234.09375 184.730469 234.171875 184.820312 234.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 238.539062 116.695312 C 241.902344 126.105469 244.910156 138.785156 244.089844 152.722656 C 246.125 155.578125 248.148438 158.503906 250.140625 161.527344 C 250.90625 146.011719 247.027344 130.316406 238.539062 116.695312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 213.761719 91.914062 C 200.222656 83.476562 184.640625 79.589844 169.21875 80.289062 C 171.574219 81.792969 174.601562 83.808594 178.152344 86.339844 C 191.921875 85.601562 204.445312 88.585938 213.761719 91.914062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 101.742188 154.472656 C 105.101562 139.445312 113.515625 124.742188 126.925781 110.855469 L 118.460938 102.394531 C 118.300781 102.554688 118.128906 102.707031 117.96875 102.867188 C 105.914062 114.921875 98.683594 129.992188 96.246094 145.671875 C 96.335938 145.789062 96.425781 145.910156 96.496094 146.042969 C 96.5625 146.167969 98.289062 149.285156 101.742188 154.472656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 100.503906 161.753906 C 98.402344 158.761719 96.707031 156.195312 95.386719 154.128906 C 94.753906 168.078125 97.871094 182.160156 104.714844 194.738281 C 100.660156 183.742188 99.253906 172.683594 100.503906 161.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#29ea824543)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b26700",
    d: "M 251.066406 236.046875 C 271.980469 215.136719 283.496094 187.339844 283.496094 157.765625 C 283.496094 128.191406 271.980469 100.398438 251.066406 79.484375 C 248.101562 76.515625 243.292969 76.515625 240.328125 79.484375 C 237.359375 82.449219 237.359375 87.257812 240.328125 90.222656 C 277.570312 127.464844 277.570312 188.066406 240.328125 225.3125 C 203.09375 262.539062 142.492188 262.554688 105.238281 225.3125 C 102.273438 222.34375 97.46875 222.34375 94.5 225.3125 C 91.535156 228.277344 91.535156 233.082031 94.5 236.046875 C 116.089844 257.628906 144.441406 268.417969 172.785156 268.417969 C 173.894531 268.417969 174.996094 268.292969 176.105469 268.261719 L 176.105469 283.265625 L 136.71875 283.265625 L 136.71875 298.453125 L 232.511719 298.453125 L 232.511719 283.265625 L 191.292969 283.265625 L 191.292969 266.777344 C 213.195312 263.089844 234.203125 252.910156 251.066406 236.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeography);
export default __webpack_public_path__ + "static/media/geography.dbd11520e9e8930941799668dc1e4023.svg";
export { ForwardRef as ReactComponent };